import type { FC } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Iconify } from '@pflegenavi/web-components';
import { Button } from '@mui/material';

interface EditOrRetractReceiptBatchButtonProps {
  editable: boolean;
  onEdit: () => void;
}

export const EditOrRetractReceiptBatchButton: FC<
  EditOrRetractReceiptBatchButtonProps
> = ({ editable, onEdit }) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="outlined"
      color="primary"
      onClick={onEdit}
      disabled={!editable}
      startIcon={
        <Iconify icon={'eva:edit-fill'} width={18} sx={{ mt: -0.2 }} />
      }
    >
      {t('receipts.batch.edit-receipt-batch')}
    </Button>
  );

  // TODO: implement retract receipt batch button
};
